import React, { FC } from "react";
import AudioPlayer from "Components/AudioPlayer";
import { useSelector, useDispatch } from "react-redux";

import {
  setAudio,
  playAudio,
  pauseAudio,
  setProgress,
} from "./AudioPlayerActions";

interface Props {
  url: String;
  icon: any;
  pauseIcon?: any;
}

const AudioPlayerContainer: FC<Props> = (props: Props) => {
  const { url, icon, pauseIcon } = props;
  const Dispatch = useDispatch();

  const { audio, isPlaying, progress } = useSelector(
    (state: any) => state.audioPlayer
  );

  if (audio && !isPlaying && progress === 0) {
    audio.stop();
  }

  return (
    <AudioPlayer
      url={url}
      icon={icon}
      pauseIcon={pauseIcon}
      audio={audio}
      setAudio={(audioFlow: any) => Dispatch(setAudio(audioFlow))}
      isPlaying={isPlaying}
      progress={progress}
      setProgress={(val: any) => Dispatch(setProgress(val))}
      playAudio={() => Dispatch(playAudio())}
      pauseAudio={() => Dispatch(pauseAudio())}
    />
  );
};

AudioPlayerContainer.defaultProps = {
  pauseIcon: null,
};

export default AudioPlayerContainer;
try {
    // @ts-ignore
    AudioPlayer.displayName = "AudioPlayer";
    // @ts-ignore
    AudioPlayer.__docgenInfo = { "description": "", "displayName": "AudioPlayer", "props": { "url": { "defaultValue": null, "description": "", "name": "url", "required": true, "type": { "name": "String" } }, "icon": { "defaultValue": null, "description": "", "name": "icon", "required": true, "type": { "name": "any" } }, "pauseIcon": { "defaultValue": null, "description": "", "name": "pauseIcon", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudioPlayer/AudioPlayer.tsx#AudioPlayer"] = { docgenInfo: AudioPlayer.__docgenInfo, name: "AudioPlayer", path: "src/shared/containers/AudioPlayer/AudioPlayer.tsx#AudioPlayer" };
}
catch (__react_docgen_typescript_loader_error) { }